import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing shadow-sm" }
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = {
  key: 0,
  class: "badge bg-secondary"
}
const _hoisted_17 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_18 = {
  key: 2,
  class: "badge bg-warning"
}
const _hoisted_19 = {
  key: 3,
  class: "badge bg-warning text-black"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_21 = { class: "dropdown" }
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "fa fa-spinner fa-spin lh-1 me-8"
}
const _hoisted_29 = {
  key: 1,
  class: "flaticon-credit-card lh-1 me-8 position-relative top-1"
}
const _hoisted_30 = { key: 3 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-8",
  role: "status"
}
const _hoisted_33 = {
  key: 1,
  class: "flaticon-file-invoice lh-1 me-8 position-relative top-1"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 4 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 5 }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 6 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-8",
  role: "status"
}
const _hoisted_42 = {
  key: 1,
  class: "flaticon-file-1 lh-1 me-8 position-relative top-1"
}
const _hoisted_43 = { key: 7 }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-8",
  role: "status"
}
const _hoisted_46 = {
  key: 1,
  class: "flaticon-file-1 lh-1 me-8 position-relative top-1"
}
const _hoisted_47 = { key: 8 }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 9 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
            to: "/ajouter/etape-1"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
              _createTextVNode(" Ajouter un BESC ", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exporterBescs && _ctx.exporterBescs(...args)))
          }, [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Exporter ", -1),
            _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un BESC"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Référence BESC "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Importateur "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Montant BESC "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Statut BESC "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Statut Paiement "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
                }, " ACTIONS ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bescs, (besc, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(besc.refbesc), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.getImportateur(besc)?.acteur.nomComplet || 'N/A'), 1),
                  _createElementVNode("td", _hoisted_11, [
                    (besc.facture)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.formatEuro(besc.facture.montantTotal)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "Non calculé"))
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getStatusClass(besc.currentStatus?.code))
                    }, _toDisplayString(_ctx.getDisplayedStatusLabel(besc)), 3)
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    (!besc.facture)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Sans facture "))
                      : (Number(besc.facture.balanceDue) === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Payé "))
                        : (besc.facture.status === 'PARTIALLY_PAID')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Partiel "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_19, " En Attente (" + _toDisplayString(_ctx.formatEuro(besc.facture.balanceDue)) + ") ", 1))
                  ]),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", {
                        class: "badge text-white bg-primary fs-15 dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false",
                        style: {"cursor":"pointer"}
                      }, [
                        _createTextVNode(" Actions "),
                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_22, [
                        (!_ctx.checkRole('Transitaire'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                              _createVNode(_component_router_link, {
                                to: { name: 'ViewBesc', params: { id: besc.id } },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Détails ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        (!besc.facture)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item d-flex align-items-center text-primary fw-bold",
                                onClick: ($event: any) => (_ctx.poursuivreCreation(besc.id))
                              }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Poursuivre la création de mon BESC ", -1)
                              ]))], 8, _hoisted_25)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.shouldShowSubmitAndPayButton(besc))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: _normalizeClass(["dropdown-item d-flex align-items-center text-success fw-bold", { 'disabled': _ctx.loadingValidation[besc.id] }]),
                                onClick: ($event: any) => (_ctx.submitAndPay(besc.id))
                              }, [
                                (_ctx.loadingValidation[besc.id])
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_29)),
                                _createTextVNode(" " + _toDisplayString(_ctx.getSubmitButtonText(besc)), 1)
                              ], 10, _hoisted_27)
                            ]))
                          : _createCommentVNode("", true),
                        (besc.facture)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.voirFacture(besc.facture.id, besc.id))
                              }, [
                                (_ctx.loadingDownload[`facture_${besc.id}`])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_33)),
                                _createTextVNode(" " + _toDisplayString(_ctx.loadingDownload[`facture_${besc.id}`] ? 'Téléchargement...' : `Voir la facture
                          (${_ctx.formatEuro(besc.facture?.montantTotal)})`), 1)
                              ], 8, _hoisted_31)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "dropdown-item d-flex align-items-center",
                            onClick: ($event: any) => (_ctx.saveDraft(besc.id))
                          }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "flaticon-file-invoice lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Actualiser la facture ", -1)
                          ]))], 8, _hoisted_34)
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("li", null, [
                          _createElementVNode("hr", { class: "dropdown-divider" })
                        ], -1)),
                        (besc.currentStatus?.code === 'DRAFT')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.modifierBesc(besc.id))
                              }, [...(_cache[10] || (_cache[10] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Mettre à jour ce Besc ", -1)
                              ]))], 8, _hoisted_36)
                            ]))
                          : _createCommentVNode("", true),
                        (besc.currentStatus?.code === 'PENDING_CORRECTION')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item d-flex align-items-center text-warning fw-bold",
                                onClick: ($event: any) => (_ctx.modifierBesc(besc.id))
                              }, [...(_cache[11] || (_cache[11] = [
                                _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Apporter des corrections ", -1)
                              ]))], 8, _hoisted_38)
                            ]))
                          : _createCommentVNode("", true),
                        (besc.currentStatus?.code === 'DRAFT')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: _normalizeClass(["dropdown-item d-flex align-items-center", { 'disabled opacity-50': _ctx.loadingDownload[besc.id] }]),
                                onClick: ($event: any) => (_ctx.telechargerBrouillon(besc.id))
                              }, [
                                (_ctx.loadingDownload[besc.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_42)),
                                _createTextVNode(" " + _toDisplayString(_ctx.loadingDownload[besc.id] ? 'Génération en cours...' : 'Télécharger brouillon'), 1)
                              ], 10, _hoisted_40)
                            ]))
                          : _createCommentVNode("", true),
                        (besc.currentStatus?.code === 'APPROVED')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: _normalizeClass(["dropdown-item d-flex align-items-center", { 'disabled opacity-50': _ctx.loadingDownload[`pdf_${besc.id}`] }]),
                                onClick: ($event: any) => (_ctx.telechargerPDF(besc.id))
                              }, [
                                (_ctx.loadingDownload[`pdf_${besc.id}`])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_45))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_46)),
                                _createTextVNode(" " + _toDisplayString(_ctx.loadingDownload[`pdf_${besc.id}`] ? 'Génération en cours...' : 'Télécharger PDF'), 1)
                              ], 10, _hoisted_44)
                            ]))
                          : _createCommentVNode("", true),
                        (besc.currentStatus?.code === 'APPROVED')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.telechargerXML(besc.id))
                              }, [...(_cache[12] || (_cache[12] = [
                                _createElementVNode("i", { class: "flaticon-code lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Télécharger XML ", -1)
                              ]))], 8, _hoisted_48)
                            ]))
                          : _createCommentVNode("", true),
                        (besc.currentStatus?.code === 'DRAFT')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item d-flex align-items-center text-danger",
                                onClick: ($event: any) => (_ctx.supprimerBesc(besc.id, besc.refbesc))
                              }, [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Supprimer ", -1)
                              ]))], 8, _hoisted_50)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.bescs.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("td", {
                      colspan: "10",
                      class: "text-center text-muted py-4"
                    }, " Aucun BESC trouvé. ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ])
  ]))
}